module.exports = __webpack_public_path__ + "img/Flucht.2bb98f2b.jpg";